import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { TranslocoModule } from '@ngneat/transloco';

import { LibSharedCommonModule } from 'projects/lib-shared-common/src/public-api';
import { SvcButtonsModule } from 'projects/lib-shared-component/src/lib/svc-buttons/svc-buttons.module';

@Component({
  selector: 'svc-action-plan-approval-button',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    TranslocoModule,
    LibSharedCommonModule,
    SvcButtonsModule,
  ],
  templateUrl: './svc-action-plan-approval-button.component.html',
  styleUrls: ['./svc-action-plan-approval-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SvcActionPlanApprovalButtonComponent {
  public readonly processing = input<boolean>(false);
  public readonly onApprove = output<void>();
  public readonly onReject = output<void>();
}
